
const patchVariantPicker = async () => {
  await window.customElements.whenDefined("variant-picker");
  const preferredVariantKeyword = "handtuch";
  let lastBaseColor = null;
  let pendingRaf = null;
  let hasInstalledObserver = false;

  const applyBaseColorToHorizontalProducts = (baseColor) => {
    for (const horizontalProduct of document.querySelectorAll(".horizontal-product")) {
      const images = Array.from(horizontalProduct.querySelectorAll(".horizontal-product__image"));
      for (const image of images) {
        image.hidden = true;
      }
      const drawer = horizontalProduct.querySelector("quick-buy-drawer");
      const sameColorHorizontalImages = images.filter(image => image.getAttribute("data-basecolor")?.trim() === baseColor);
      const preferredSameColorHorizontalImage = sameColorHorizontalImages.find(image => {
        const variantTitle = image.getAttribute("data-variant-title")?.toLowerCase()?.trim();
        return variantTitle?.includes(preferredVariantKeyword);
      });
      const sameColorHorizontalImage = preferredSameColorHorizontalImage || sameColorHorizontalImages[0];
      if (sameColorHorizontalImage) {
        sameColorHorizontalImage.hidden = false;
        const handle = sameColorHorizontalImage.getAttribute("data-handle");
        if (handle && drawer) {
          drawer.setAttribute("handle", handle);
          drawer._hasLoaded = false;
        }
        continue;
      }
      const fallbackHorizontalImage = images.find(image => !image.hasAttribute("data-basecolor"));
      if (fallbackHorizontalImage) {
        fallbackHorizontalImage.hidden = false;
        const handle = fallbackHorizontalImage.getAttribute("data-handle");
        if (handle && drawer) {
          drawer.setAttribute("handle", handle);
          drawer._hasLoaded = false;
        }
      }
    }
  };

  const applyBaseColorToProductCards = (baseColor) => {
    for (const optionList of document.querySelectorAll(".shopify-section--product-recommendations .product-card__swatch-list, .shopify-section--product-recommendations .product-card__variant-list, .shopify-section--recently-viewed-products .product-card__swatch-list, .shopify-section--recently-viewed-products .product-card__variant-list")) {
      const input = optionList.querySelector(`input[data-basecolor="${baseColor}"]`)
      if (!input) {
        continue;
      }
      const label = input.nextElementSibling;
      if (label && label.classList.contains("hidden")) {
        const siblings = optionList.querySelectorAll("label");
        if (siblings.length > 4) {
          const visibleSiblings = Array.from(siblings).filter(sibling => !sibling.classList.contains("hidden"));
          visibleSiblings[visibleSiblings.length - 1]?.classList.add("hidden");
        }
        label.classList.remove("hidden");
      }
      if (!input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  };

  const scheduleApply = () => {
    if (!lastBaseColor) {
      return;
    }
    if (pendingRaf) {
      cancelAnimationFrame(pendingRaf);
    }
    pendingRaf = requestAnimationFrame(() => {
      pendingRaf = null;
      lastBaseColor && applyBaseColorToHorizontalProducts(lastBaseColor);
      lastBaseColor && applyBaseColorToProductCards(lastBaseColor);
    });
  };

  const VariantPickerClass = window.customElements.get("variant-picker");
  if (!VariantPickerClass || VariantPickerClass.__patchedByCustomJs) {
    return;
  }

  const originalSelectCombination = VariantPickerClass.prototype.selectCombination;

  VariantPickerClass.prototype.selectCombination = async function patchedSelectCombination(...args) {
    const result = await originalSelectCombination.apply(this, args);

    const selectorElement = this.querySelector(`.variant-picker__option-values > input[data-basecolor][data-variant-id="${this.selectedVariant?.id}"]`);
    const baseColor = selectorElement?.getAttribute("data-basecolor")?.trim();
    if (baseColor) {
      lastBaseColor = baseColor;
      baseColor && applyBaseColorToHorizontalProducts(baseColor);
      baseColor && applyBaseColorToProductCards(baseColor);
      scheduleApply();
    }
    if (!hasInstalledObserver) {
      hasInstalledObserver = true;
      const observer = new MutationObserver(() => scheduleApply());
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
    return result;
  };

  VariantPickerClass.__patchedByCustomJs = true;

  const mainVariantPicker = document.querySelector(".shopify-section--main-product variant-picker[form-id]");
  const variantInput = mainVariantPicker?.querySelector(`input[data-variant-id="${mainVariantPicker?.selectedVariant?.id}"]`);
  variantInput?.dispatchEvent(new Event("change", { bubbles: true }));
};

patchVariantPicker();